<template>
  <div class="view-mode-toggle" role="radiogroup" :aria-label="ariaLabel">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="radio"
      :aria-checked="modelValue === opt.value"
      :class="['view-mode-toggle__btn', { 'is-active': modelValue === opt.value }]"
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, required: true },
  options: {
    type: Array,
    default: () => [
      { value: 'list', label: 'List' },
      { value: 'groups', label: 'Groups' },
    ],
  },
  ariaLabel: { type: String, default: 'View mode' },
});
defineEmits(['update:modelValue']);
</script>

<style scoped>
.view-mode-toggle {
  display: inline-flex;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  margin-bottom: 1rem;
}

.view-mode-toggle__btn {
  padding: 0.45rem 1rem;
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.view-mode-toggle__btn + .view-mode-toggle__btn {
  border-left: 1px solid #d1d5db;
}

.view-mode-toggle__btn:hover:not(.is-active) {
  background: #f1f5f9;
}

.view-mode-toggle__btn.is-active {
  background: var(--highlights, #2563eb);
  color: #ffffff;
}
</style>
